import { OrderedDogsUnits, OrderedCatsUnits, OrderedCatsCollarUnits } from '@store/partners-order/OrderedUnits';
import { DeliveryTypeDef } from '@api/types/DeliveryTypeDef';
import { PaymentTypeDef } from '@api/types/PaymentTypeDef';
import { DispatchPoint } from '@api/types/DispatchPoint';
import { AppLanguageCode } from '@project-types/AppLanguageCodes';
import { getCurrentLanguageCode } from '@translations/functions';



export interface PartnersOrderState {
	showInvalids: boolean,
	customer: string | null,
	email: string | null,
	phoneNumber: string | null,
	street: string | null,
	city: string | null,
	postalCode: string | null,
	invoiceStreet: string | null,
	invoiceCity: string | null,
	invoicePostalCode: string | null,
	registrationNumber: string | null,
	vatnumber: string | null,
	message: string | null,
	payment: PaymentTypeDef | null,
	delivery: DeliveryTypeDef | null,
	dispatchPoint: DispatchPoint | null,
	orderedDogsUnits: OrderedDogsUnits,
	orderedCatsUnits: OrderedCatsUnits,
	orderedCatsCollarUnits: OrderedCatsCollarUnits,
	testSamples: boolean,
	country: AppLanguageCode,
};

export const initialState: PartnersOrderState = {
	showInvalids: false,
	customer: null,
	email: null,
	phoneNumber: null,
	street: null,
	city: null,
	postalCode: null,
	invoiceStreet: null,
	invoiceCity: null,
	invoicePostalCode: null,
	registrationNumber: null,
	vatnumber: null,
	message: null,
	payment: null,
	delivery: null,
	dispatchPoint: null,
	orderedDogsUnits: {
		sizeS: 0,
		sizeM: 0,
		sizeL1: 0,
		sizeL2: 0,
		sizeXL1: 0,
		sizeXL2: 0,
		sizeXXL1: 0,
		sizeXXL2: 0,
		size3XL1: 0,
		size3XL2: 0,
		size4XL1: 0,
		size4XL2: 0,
		size5XL: 0,

		sizeXLMini: 0,
		size4XLMini: 0,
		size3XLMini: 0,
		size2XLMini: 0,
	},
	orderedCatsUnits: {
		sizeS: 0,
		sizeM: 0,
		sizeL: 0,
	},
	orderedCatsCollarUnits: {
		sizeS: 0,
		sizeM: 0,
		sizeL: 0,
	},
	testSamples: false,
	country: getCurrentLanguageCode(),
};